/**
 * An invitation link opened while signed out (M-01): kept for the trip
 * through sign-in or sign-up (the magic link and Google leave the app and
 * come back to a fixed URL), so the person lands back on the invite page
 * before any brand screen mounts. Only a link token is kept, never a URL.
 */
const KEY = 'unipostudio.pendingInvite';
const MAX_AGE_MS = 60 * 60 * 1000;
const TOKEN = /^[A-Za-z0-9_-]{43}$/;

export function rememberPendingInvite(token: string): void {
  if (!TOKEN.test(token)) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, at: Date.now() }));
  } catch {
    /* storage unavailable: the person opens the link again */
  }
}

/** The kept token, if fresh. Does not clear it. */
export function peekPendingInvite(now: number = Date.now()): string | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { token?: unknown; at?: unknown };
    if (typeof parsed.token !== 'string' || !TOKEN.test(parsed.token) || typeof parsed.at !== 'number' || now - parsed.at > MAX_AGE_MS) return null;
    return parsed.token;
  } catch {
    return null;
  }
}

export function clearPendingInvite(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}
